import { h3SetToMultiPolygon } from 'h3-js';
import React from 'react';

const isMyMap = (map) => (map && map._mapView && map._mapView._mapDiv.id === "naver-map");

class NaverMap extends React.Component {
  componentDidMount() {
    if (!window.naver) return;
    const domId = "naver-map";
    const map = new window.naver.maps.Map(domId, {
      center: new window.naver.maps.LatLng(37.535235, 127.094842),
      zoom: 12
    });
    this.props.setMap(map);
  }

  render() {
    return (
      <>
        <div id="naver-map" style={{ height: window.innerHeight - 56 }}></div>
      </>
    );
  }
}

const NaverMapMarker = (props) => {
  const { map, markers } = props;

  isMyMap(map) && markers.forEach(m => {
    const marker = new window.naver.maps.Marker({
      position: new window.naver.maps.LatLng(m.position[0], m.position[1]),
      map
    });

    const info = new window.naver.maps.InfoWindow({
      content: `<div style="padding:4px">${m.name}</div>`
    });

    window.naver.maps.Event.addListener(marker, 'click', () => {
      info.open(map, marker);
    });
  });

  return (<></>);
};

const NaverMapCircle = (props) => {
  const { map, circles } = props;

  isMyMap(map) && circles.forEach(circle => {
    new window.naver.maps.Circle({
      center: new window.naver.maps.LatLng(circle.center[0], circle.center[1]),
      radius: circle.radius,
      map,
      ...circle.style
    });
  });

  return (<></>);
}

const NaverMapIndex = (props) => {
  const { map, indexes } = props;

  isMyMap(map) && indexes.forEach(idx => {
    const multiPolygon = h3SetToMultiPolygon([idx], true);
    multiPolygon.forEach(polygon => {
      const boundary = polygon[0] || [];
      const paths = boundary.map(coords => (new window.naver.maps.LatLng(coords[1], coords[0])));
      new window.naver.maps.Polygon({
        paths,
        map,
        ...polygon.style
      });
    });
  });

  return (<></>);
}

export { NaverMap, NaverMapCircle, NaverMapMarker, NaverMapIndex };
